import styled from "styled-components/macro";
import { Link } from "@ds/react";

export const StyledLink = styled(Link)(({ theme: { color } }) => ({
  color: color.brandSecondary.light,
}));

export const Box = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  minHeight: "200px",
}));
